/* eslint-disable no-underscore-dangle */
import Url from '@music/mobile-url';
import { makeActionCreator, makeActionType, getActionType } from '../util/redux';
import Request from '../util/fetch';
import { Toast } from '../component/message';

export const PAGESIZE = 15;
export const WorkType = 'mlog';
const mockUserId = Url.CurrentParams.mockUserId || '';

makeActionType(WorkType, ['request0', 'request1', 'delrequest', 'delcomplete', 'savepage', 'tryrequest', 'trycomplete', 'clearsgtab', 'edititem', 'querylistrequest', 'queryliststatus']);
export const worksClear = makeActionCreator(getActionType(WorkType, 'clear'));
export const worksSuccess = makeActionCreator(getActionType(WorkType, 'success'));
export const worksFail = makeActionCreator(getActionType(WorkType, 'fail'));
export const worksComplete = makeActionCreator(getActionType(WorkType, 'delcomplete'));
export const worksSavePage = makeActionCreator(getActionType(WorkType, 'savepage'));
export const worksTryComplete = makeActionCreator(getActionType(WorkType, 'trycomplete'));
export const worksClearTab = makeActionCreator(getActionType(WorkType, 'clearsgtab'));
export const worksEidtItem = makeActionCreator(getActionType(WorkType, 'edititem'));
export const worksQueryList = makeActionCreator(getActionType(WorkType, 'queryliststatus'));

/**
 * 发布状态：发布中（0），已发布（1）、发布失败（-1）
 */
export const PublishType = {
    publishing: 0,
    published: 1,
    publishFailed: -1,
};

export const TabType = {
    published: 0,
    publishing: 1,
};

export const TabToPublishTypeMap = {
    [TabType.published]: PublishType.published,
    [TabType.publishing]: PublishType.publishing
};

export const mlogRequest = data => (dispatch) => {
    const type = TabToPublishTypeMap[data.status];
    const {
        status, // 0, 1
        page,
    } = data;
    dispatch({
        type: getActionType(WorkType, `request${status}`),
        payload: data
    });
    return Request.fetch({
        url: '/api/mlog/admin/mymlog/publog/get',
        data: {
            type,
            limit: PAGESIZE,
            offset: (page - 1) * PAGESIZE,
        }
    }).then((result) => {
        const resData = result.data;
        resData._status = status;
        resData._page = page;
        dispatch(worksSuccess(resData));
    })
        .catch((error) => {
            const rerr = Request.resolveError(error);
            rerr._status = status;
            dispatch(worksFail(rerr));
        });
};

// 删除
export const mlogDelRequest = data => (dispatch) => {
    const {
        status, // 0, 1
        page,
        videoId
    } = data;
    dispatch({
        type: getActionType(WorkType, 'delrequest'),
        payload: {
            videoId
        }
    });

    return Request.fetch({
        url: '/api/mlog/delete',
        data: {
            mlogId: videoId,
        }
    })
        .then(() => {
            Toast({
                type: 'success',
                text: '删除成功'
            });
            if (page) {
                dispatch(worksComplete({
                    success: true,
                    page,
                    status,
                    videoId
                }));
            }
        })
        .catch((error) => {
            const rerr = Request.resolveError(error);
            Toast({
                type: 'error',
                text: rerr.msg
            });
            dispatch(worksComplete(rerr));
        });
};

// 重新发布
// export const workTryRequest = data => (dispatch) => {
//     // 0, 1, 2
//     const cmode = parseInt(data.status, 10);
//     const page = data.page;
//     const videoId = data.videoId;
//     dispatch({
//         type: getActionType(WorkType, 'tryrequest'),
//         payload: {
//             videoId
//         }
//     });
//     return Request.fetch({
//         url: 'api/cloudvideo/video/republish',
//         data: {
//             videoId,
//             mockUserId
//         }
//     })
//         .then((data) => {
//             dispatch(worksTryComplete({
//                 success: true,
//                 page,
//                 status: cmode,
//                 videoId
//             }));
//         })
//         .catch((error) => {
//             const rerr = Request.resolveError(error);
//             Toast({
//                 type: 'error',
//                 text: rerr.msg
//             });
//             dispatch(worksTryComplete(rerr));
//         });
// };
// 查询抓取和转码状态
// export const workQueryRequest = data => (dispatch) => {
//     data = data || [];
//     const page = data.page;
//     delete data.page;
//     dispatch({
//         type: getActionType(WorkType, 'querylistrequest')
//     });
//     if (data.videoIds) {
//         data.videoIds = JSON.stringify(data.videoIds);
//     }
//     data.mockUserId = mockUserId;
//     return Request.fetch({
//         url: 'api/cloudvideo/video/status/get/v2',
//         data
//     })
//         .then((result) => {
//             // console.log('==query==', data);
//             const arr = result.data,
//                 qrsData = {};
//             // 查询是否有完成发布
//             let isFinish = false;
//             for (const { videoId, publishStatus } of arr.values()) {
//                 if (publishStatus == 1) {
//                     isFinish = true;
//                 }
//                 qrsData[videoId] = publishStatus;
//             }
//             if (isFinish) {
//                 dispatch(worksQueryList({
//                     success: true,
//                     data: qrsData,
//                     page
//                 }));
//                 // 清空第一个tab且请求
//                 dispatch(mlogRequest({
//                     status: 1,
//                     page: 1,
//                     _clear: true // 请求的时候清空之前的数据
//                 }));
//             } else {
//                 dispatch(worksQueryList({}));
//             }
//         })
//         .catch((error) => {
//             const rerr = Request.resolveError(error);
//             dispatch(worksQueryList(rerr));
//         });
// };



// WEBPACK FOOTER //
// ./client/action/mlog.js